<template>
  <a-modal
    title="打印机服务"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    ok-text="打印"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="mb-10">打印前请确认您已经安装打印驱动，未安装请
      <a-button
        type="link"
        @click="downloadSetup"
      >点击此处</a-button>
      安装；确认打印驱动已开启，设置驱动Port为2012，SPlit为| ；确认打印机已开启且连线成功，未连线请点击
      <a-button
        type="link"
        size="small"
        @click="connection"
      >连线</a-button>
      <!-- 或
      <a-button
        type="link"
        @click="getStatus"
      >查询状态</a-button> -->
      。
    </div>
    <!-- <div class="mb-20">2、打印前请确认打印驱动已开启，设置驱动Port为2012，SPlit为|;</div>
    <div class="mb-20">3、打印前请确认打印机已开启且连线成功。未连线请点击
      <a-button
        type="link"
        size="small"
        @click="connection"
      >连线</a-button>
      。
    </div> -->
    <div class="mb-20">打印机状态：<span class="green f18">{{ status || '未连线' }}</span>
      <a-button
        type="link"
        @click="getStatus"
      >查询状态</a-button>
    </div>
    <a-form-model
      ref="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="水平偏移(mm)">
        <a-input-number v-model="hor" />
      </a-form-model-item>
      <a-form-model-item label="垂直偏移(mm)">
        <a-input-number v-model="ver" />
      </a-form-model-item>
      <a-form-model-item label="打印深度" extra="设定打印头打印热度，范围：0～15">
        <a-input-number v-model="darkness" :min="0" :max="15" :step="1" />
      </a-form-model-item>
      <a-form-model-item
        label="dot/mm"
        extra="大部分打印机该值为12或8"
      >
        <a-input-number v-model="mul" />
      </a-form-model-item>
    </a-form-model>
    <!-- <div>总张数：{{ printData.unit.length }} 张，已打印：{{ alreadyNum }} 张</div> -->
    <!-- <a-button
      type="primary"
      size="small"
      class="mr-10"
      @click="startPrint"
    >
      打印
    </a-button> -->
  </a-modal>
</template>

<script>
var ws
var wsUrl = 'ws://localhost:2012' // 打印后台地址与

export default {
  data() {
    return {
      hor: 0, // 水平偏移
      ver: 0, // 垂直偏移
      darkness: 9, // 打印深度
      mul: 12, // 一般打印机 12dot等于1mm
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      visible: false,
      confirmLoading: false,
      status: '', // 打印机状态
      alreadyNum: 0,
      picArr: []
    }
  },
  props: {
    printData: {
      type: Object,
      default: () => {
        return {
          // size: '62*25',
          // space: 2,
          // gap: 2,
          // unit: [
          //   {
          //     type: 'QRCODE',
          //     top: 0,
          //     left: 0,
          //     width: 20,
          //     height: 20,
          //     picture:
          //       'http://czdongsheng.oss-cn-shenzhen.aliyuncs.com/ATTRIBUTE/20210312/d9e398c1c33618ac243f85c3bf6be434.bmp'
          //   },
          //   {
          //     type: 'TEXT',
          //     top: 20,
          //     left: 0,
          //     width: 50,
          //     height: 5,
          //     font_size: 2,
          //     line_height: 5,
          //     goods_field: '',
          //     text: '文本文本文本撒啊杀'
          //   },
          //   {
          //     type: 'TEXT',
          //     top: 0.4,
          //     left: 20,
          //     width: 10,
          //     height: 5,
          //     font_size: 2,
          //     line_height: 5,
          //     goods_field: '',
          //     text: '炒炒炒'
          //   },
          //   {
          //     type: 'TEXT',
          //     top: 10,
          //     left: 20,
          //     width: 10,
          //     height: 5,
          //     font_size: 3,
          //     line_height: 5,
          //     goods_field: '',
          //     text: '啦啦啦'
          //   },
          //   {
          //     type: 'PIC',
          //     top: 0,
          //     left: 32,
          //     width: 30,
          //     height: 20,
          //     picture:
          //       'http://czdongsheng.oss-cn-shenzhen.aliyuncs.com/ATTRIBUTE/20210311/fdc418a3846886060dd20e00d4831ed3.bmp'
          //   },
          //   {
          //     type: 'TEXT',
          //     top: 20,
          //     left: 40,
          //     width: 10,
          //     height: 5,
          //     font_size: 2,
          //     line_height: 5,
          //     goods_field: '',
          //     text: '文啊啊啊'
          //   }
          // ]
        }
      }
    }
  },
  methods: {
    showModal(id = 0) {
      this.visible = true
      this.connection()
      console.log(this.printData)
    },
    handleOk(e) {
      this.startPrint()
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
    },
    // 下载打印驱动
    downloadSetup() {
      // window.location.href = 'https://8899-city.oss-cn-shenzhen.aliyuncs.com/soft/%E6%89%93%E5%8D%B0%E6%9C%BA%E5%AE%89%E8%A3%85%E5%8C%85.zip'
      const href = 'https://8899-city.oss-cn-shenzhen.aliyuncs.com/soft/%E6%89%93%E5%8D%B0%E6%9C%BA%E5%AE%89%E8%A3%85%E5%8C%85.zip'
      this.downloadFile(href)
    },
    downloadFile(url) {
      try {
        var elemIF = document.createElement('iframe')
        elemIF.src = url
        elemIF.style.display = 'none'
        document.body.appendChild(elemIF)
      } catch (e) {
        alert('下载异常！')
      }
    },
    // 连接打印机
    connection() {
      const that = this
      if ('WebSocket' in window) {
        ws = new WebSocket(wsUrl)
      } else if ('MozWebSocket' in window) {
        // eslint-disable-next-line
        ws = new MozWebSocket(wsUrl)
      } else {
        that.status = '当前浏览器不支持'
        alert('当前浏览器不支持')
      }

      // 注册各类回调
      ws.onopen = function() {
        that.status = '连接打印后台成功'
        that.$message.success('连接打印后台成功')
      }

      ws.onclose = function() {
        that.status = '与打印后台断开连接'
        that.$message.warning('与打印后台断开连接')
        alert('与打印后台断开连接')
      }
      ws.onerror = function() {
        that.status = '数据传输发生错误'
        that.$message.error('数据传输发生错误')
        alert('数据传输发生错误')
      }
      ws.onmessage = function(receiveMsg) {
        if (receiveMsg.data.split('|')[0] === 'B_GetPrinterStatus') {
          var ret = Number(receiveMsg.data.split('|')[1])
          console.log(receiveMsg)
          console.log(ret)
          if (ret === 2) {
            that.status = '2:USB端口开启失败'
          } else if (ret === 7) {
            that.status = '7:纸张/碳带用完！'
          } else if (ret === 4) {
            that.status = '4:内存溢出！' // 4:内存溢出！
          } else if (ret === 4) {
            that.status = '4 碳带用完或安装错误！' // 碳带用完或安装错误！";
          } else if (ret === 3) {
            that.status = '3:条码格式错误！' // 3:条码格式错误！";
          } else if (ret === 1) {
            that.status = '1:打印命令错误！' // 1:打印命令错误！
          } else if (ret === 6) {
            that.status = '6:串口通信异常！' // 6:串口通信异常！
          } else if (ret === 50) {
            that.status = '50:打印机忙碌！' // 50:打印机忙碌！
          } else if (ret === 12) {
            that.status = '12:打印机暂停！' // 12:打印机暂停
          } else if (ret === 11) {
            that.status = '11:打印头松动' // 9:print Head Up(Open)
          } else if (ret === 81) {
            that.status = '81:刀具故障' // 81:cutter fail
          } else if (ret === 9) {
            that.status = '9:未取得返回值' // 9:未取得返回值
          }
          //  else if (ret === 0) {
          //   that.status = '0:等待列印!' // 0:等待列印!
          // }
        }
      }
    },
    // 获取打印机状态
    getStatus() {
      if (!ws) {
        this.connection()
      } else {
        ws.send('B_EnumUSB')
        ws.send('B_CreateUSBPort|1')
        ws.send('B_GetPrinterStatus')
        ws.send('B_ClosePrn')
      }
    },
    // 尝试向打印后台发送消息
    sendMessage(unit, index) {
      ws.send('B_EnumUSB')
      ws.send('B_CreateUSBPort|1')
      // 打印深度
      ws.send(`B_Set_Darkness|${this.darkness}`)
      // 纸张设置
      const size = this.printData.size
      const gap = this.printData.gap
      const sizeArr = size.split('*')
      const pageW = parseFloat(sizeArr[0]) || 0
      const pageH = parseFloat(sizeArr[1]) || 0
      ws.send(`B_Set_LabelForSmartPrint|${pageH * this.mul}|${gap * this.mul}`) // 设定纸张高度15mm，单位0.1mm，高度间隙2mm
      ws.send(`B_Set_Labwidth|${pageW * this.mul}`) // 设置纸张宽度，单位dot 1mm=12dot（300dpi）
      for (let i = 0; i < unit.length; i++) {
        const item = unit[i]
        if (item.type === 'QRCODE' && item.picture) {
          // 使用打印机插件生成二维码，二维码大小无法固定
          // ws.send(`B_Bar2d_QR|${Math.round((item.left + this.hor) * this.mul)}|${Math.round((item.top + this.ver) * this.mul)}|2|${Math.round(item.width / 4)}|L|A|0|0|0|${item.picture}`)
          // 使用图片打印二维码
          const arr = item.picture.split('/')
          const picName = arr[arr.length - 1]
          ws.send(`DownloadFile|${item.picture}|${picName}`)
          ws.send(
            `B_Get_Graphic_ColorBMPEx|${Math.round((item.left + this.hor) * this.mul)}|${Math.round(
              (item.top + this.ver) * this.mul
            )}|${Math.round(item.width * this.mul)}|${Math.round(item.height * this.mul)}|0|${i}|${picName}`
          )
        }
        if (item.type === 'TEXT') {
          // const id_name = '' + item.text + item.font_size
          // console.log(id_name)
          ws.send(
            `B_Prn_Text_TrueType|${Math.round((item.left + this.hor) * this.mul)}|${Math.round(
              (item.top + this.ver) * this.mul
            )}|${Math.round(item.font_size * this.mul)}|黑体|1|600|0|0|0|${i}|${item.text}`
          )
        }
        if (item.type === 'PIC') {
          const arr = item.picture.split('/')
          const picName = arr[arr.length - 1]
          if (!this.picArr.includes(item.picture)) {
            this.picArr.push(item.picture)
            ws.send(`DownloadFile|${item.picture}|${picName}`)
          }
          ws.send(
            `B_Get_Graphic_ColorBMPEx|${Math.round((item.left + this.hor) * this.mul)}|${Math.round((item.top + this.ver) * this.mul)}|${Math.round(item.width * this.mul)}|${Math.round(item.height * this.mul)}|0|${i}|${picName}`
          )
        }
      }
      ws.send('B_Print_Out|1')
      ws.send('B_ClosePrn')
      // 打印第几个
      this.alreadyNum = index
      // 打印最后一个
      if (this.alreadyNum === this.printData.unit.length) {
        this.$message.success('打印命令已全部下发，等待打印机打印...')
        this.confirmLoading = false
        // this.visible = false
        this.$emit('close')
      }
    },
    startPrint() {
      if (!ws) {
        this.$message.warning('请检查您的打印机是否连线？')
        return
      }
      if (this.status !== '连接打印后台成功') {
        this.$message.warning('请检查您的打印机状态')
        return
      }
      this.confirmLoading = true
      this.alreadyNum = 0
      for (let i = 1; i <= this.printData.unit.length; i++) {
        const unit = this.printData.unit[i - 1]
        this.sendMessage(unit, i)
      }
    }
  }
}
</script>
